export enum LobbySocketEventNames {
  RoomCreated = 'roomCreated',
  RoomClosed = 'roomClosed',
  RoomUpdated = 'roomUpdated',
  SessionClosed = 'sessionClosed',
  GuideProfileUpdated = 'guideProfileUpdated',
  ParticipantJoinedRoom = 'participantJoinedRoom',
  ParticipantLeftRoom = 'participantLeftRoom',
  UserBanned = 'userBanned'
}
